import { useDispatch } from "react-redux";
import HorizontalSlider from "../common/components/HorizontalSlider";
import { internalExternal } from "../features/listenerProfile";
import { useTranslation } from "react-i18next";
import VerticalCenter from "../common/components/VerticalCenter";
import Center from "../common/components/Center";
import Padding from "../common/components/Padding";

export default function Question3InternalExternal() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <>
      <Padding>
        <Center>
          <h1>
            {t(
              "Do you believe that change comes from inside or outside of us?"
            )}
          </h1>
        </Center>
      </Padding>
      <VerticalCenter>
        <HorizontalSlider
          leftElement={<p>{t("Inside")}</p>}
          values={[1, 2.33, 3.66, 5]}
          defaultValue={2.33}
          onChange={(value) => dispatch(internalExternal(value))}
          rightElement={<p>{t("Outside")}</p>}
        />
      </VerticalCenter>
    </>
  );
}
